module.exports = "https://static.wanderu.com/static/media/chiku-on-the-beach.9dfe06f7.png";